import i18n from 'i18next';
import 'dayjs/locale/ko';
import 'dayjs/locale/en';
import 'dayjs/locale/zh-tw';
import 'dayjs/locale/ja';
import React, { useMemo, useRef } from 'react';
import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider as AntdConfigProvider } from 'antd';
import routes from '@app/routes';
import { PCTheme } from '@app/assets/theme/theme';
import 'dayjs/locale/ko';
import 'dayjs/locale/en';
import 'dayjs/locale/zh-tw';
import 'dayjs/locale/ja';
import './App.css';


import userStore from './stores/userStore';

import { ToastProvider } from './context/ToastContext';
import { AxiosProvider } from './context/AxiosContext';
import { NotificationProvider } from './context/NotificationContext';
import { FCMProvider } from './context/FCMContext';
// import { BroadcastProvider } from './context/BroadcastContext';
import AuthLayout from './components/layout/AuthLayout';
import NoAuthLayout from './components/layout/NoAuthLayout';
import { isMobile } from 'react-device-detect';
import MobileAuthLayout from './components/layout/MobileAuthLayout';
import settingStore from './stores/settingStore';
import { localeMap } from './object/locale';
import { isLooseEqual } from '@app/utils/equality';



function App() {
  const { myInfo } = userStore();
  const { language } = settingStore();
  // 최초 마운트 때만 언어를 적용하던 기존 실행 시점을 유지하기 위해 초기값을 보관합니다.
  const initialLanguageRef = useRef(language);
  const AntLocale = useMemo(() => {
    return localeMap?.[language];
  }, [language]);

  useEffect(() => {
    const initialLanguage = initialLanguageRef.current;
    // i18n 변경 // test
    i18n.changeLanguage(initialLanguage); // setLanguage로 변경 시 i18n 변경은 settingStore에서 처리하지 않고 여기에만 처리하도록 수정
    const newTitle =
      isLooseEqual(initialLanguage, 'ko')
        ? 'O.C.C 호텔'
        : isLooseEqual(initialLanguage, 'en')
          ? 'O.C.C Hotel'
          : isLooseEqual(initialLanguage, 'jp')
            ? 'O.C.C ホテル'
            : isLooseEqual(initialLanguage, 'cn')
              ? 'O.C.C 飯店'
              : 'O.C.C 호텔';
    document.title = newTitle; // 언어 변경 시 사이트 제목 변경
  }, []);
  useEffect(() => {
    // if ('serviceWorker' in navigator) {
    //   navigator.serviceWorker.ready
    //     .then((registration) => {
    //       const serviceWorker =
    //         registration.active ||
    //         registration.waiting ||
    //         registration.installing;
    //       console.log(registration);
    //       if (serviceWorker) {
    //         console.log('Service Worker is active:', serviceWorker);
    //         // 여기서 serviceWorker를 사용할 수 있습니다.
    //       }
    //     })
    //     .catch((error) => {
    //       console.error('ServiceWorker is not ready:', error);
    //     });
    // }
    // // if ('serviceWorker' in navigator) {
    // //   navigator.serviceWorker
    // //     .register('/firebase-messaging-sw.js')
    // //     .then(function (reg) {
    // //       console.log('서비스워커 등록성공 :', reg);
    // //       navigator.serviceWorker.ready.then((registration) => {
    // //         const isPWA =
    // //           window.matchMedia('(display-mode: standalone)').matches ||
    // //           window.navigator.standalone;
    // //         // alert(`isPWA : ${isPWA ? 'Y' : 'N'}`);
    // //         registration.active.postMessage({
    // //           type: 'SET_PWA_STATE',
    // //           isPWA: isPWA,
    // //         });
    // //       });
    // //     })
    // //     .catch(function (error) {
    // //       console.log('서비스워커 등록실패 :', error);
    // //     });
    // // }
  }, []);

  return (
    <ToastProvider>
      <AxiosProvider>
        <AntdConfigProvider locale={AntLocale} theme={PCTheme}>
          <NotificationProvider>
            <BrowserRouter>
              <Routes>
                <Route element={<FCMProvider />}>
                  <Route element={<NoAuthLayout />}>
                    {routes.noAuthRoutes.map((route, i) => {
                      return (
                        <Route key={i} element={<route.layout />}>
                          {route.contents.map((contents, j) => {
                            return (
                              <Route
                                key={j}
                                path={contents.path}
                                name={contents.name}
                                element={<contents.component />}
                              />
                            );
                          })}
                        </Route>
                      );
                    })}
                  </Route>
                  {/* <Route element={<BroadcastProvider />}> */}
                  <Route
                    element={isMobile ? <MobileAuthLayout /> : <AuthLayout />}
                  >
                    {isMobile ? (
                      <>
                        {routes?.mobileAuthRoutes?.map((route, i) => {
                          return (
                            <Route
                              key={route.path}
                              path={route.path}
                              element={<route.layout />}
                            >
                              {route.children.map((children, j) => {
                                return (
                                  <Route
                                    key={children.path}
                                    path={children.path}
                                    element={<children.component />}
                                  />
                                );
                              })}
                            </Route>
                          );
                        })}
                      </>
                    ) : (
                      <>
                        {routes.authRoutes.map((route, i) => {
                          return (
                            <Route
                              key={i}
                              path={route.path}
                              element={<route.layout />}
                            >
                              {route.contents.map((contents, j) => {
                                //관리자의 경우에만 설정탭 사용 가능
                                if (
                                  contents?.path?.indexOf('/setting/employee') >
                                    -1 &&
                                  myInfo?.authority !== 'ROLE_HOTEL_MANAGER'
                                )
                                  return null;

                                return (
                                  <Route
                                    key={j}
                                    path={contents.path}
                                    name={contents.name}
                                    element={<contents.component />}
                                  />
                                );
                              })}
                            </Route>
                          );
                        })}
                      </>
                    )}
                  </Route>
                  <Route
                    path="*"
                    element={<Navigate to={routes.defaultPath} />}
                  />
                  {/* </Route> */}
                </Route>
              </Routes>
            </BrowserRouter>
          </NotificationProvider>
        </AntdConfigProvider>
      </AxiosProvider>
    </ToastProvider>
  );
}




export default App;
